import { deviceOnlyRule } from '../diagnostics/rules/device-only-rule'
import { hiddenEntitiesRule } from '../diagnostics/rules/hidden-entities-rule'
import { marginRule } from '../diagnostics/rules/margin-rules'
import { masterBlockRule } from '../diagnostics/rules/master-block-rule'
import { rawHtmlRule } from '../diagnostics/rules/raw-html-rule'
import { stickySectionRule } from '../diagnostics/rules/sticky-section-rule'
import { DiagnosticRule } from '../diagnostics/types'

export const diagnosticRules: DiagnosticRule[] = [
  hiddenEntitiesRule,
  deviceOnlyRule,
  marginRule,
  stickySectionRule,
  rawHtmlRule,
  masterBlockRule,
]

export const ruleNames: Record<string, string> = Object.fromEntries(
  diagnosticRules.map(r => [r.id, r.name]),
)
